import React, { useEffect } from "react";
import { Container, Row, Col, Navbar, Nav, Button, Card, Badge } from 'react-bootstrap';
import { FaWater, FaTshirt, FaGem, FaWind, FaSearch, FaClock } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

import "./FreshClean.css";
import AOS from "aos";
import "aos/dist/aos.css";
const cleanpres = "/sabmenu/woman-holding-pile-clean-clothes.jpg";

const pressImg =
  "/images/OIP.jpg";
function FreshClean() {
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({
      duration: 1200,
      easing: "ease-in-out",
      once: true,
      offset: 80,
    });
  }, []);
  return (
    <div>
      <section className="hero-section-freash-clean mt-4">
        <div className="hero-overlay-freash-clean">
          <Container fluid="xl" className="py-5 mt-4 h-100">
            <Row className="align-items-center justify-content-center text-center h-100">
              <Col lg={8}>
                <h1 className="hero-title mb-4">
                  DRY CLEANING Professional Care
                  <span className="hero-highlight">
                    for Your Most Valued Pieces
                  </span>

                </h1>

                <div className="d-flex justify-content-center flex-wrap gap-3 mt-4">
                  {/* <Button className="hero-btn-dark">
              SCHEDULE A COLLECTION
            </Button> */}

                  <button className="view-prices-list"
                    onClick={() => navigate("/laundry-price")}
                  >
                    VIEW PRICE LIST
                  </button>
                  <button className="view-prices-list"
                    onClick={() =>
                      window.open(
                        "https://api.whatsapp.com/send?phone=971545718455&text=Hi,%20I%20would%20like%20to%20book%20a%20laundry%20pickup.",
                        "_blank"
                      )
                    }
                  >
                    BOOK NOW
                  </button>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </section>

      {/* Philosophy */}
      <section className="py-5 border-top archival-section">
        <Container fluid="xl" className="py-5">

          {/* HEADING */}
          <Row className="mb-5">
            <Col md={12} className="text-center">
              <h2 className="expertise-title">
                The Archival Standard of Fabric Preservation
              </h2>
              <div className="title-accent"></div>
            </Col>
          </Row>

          {/* CONTENT */}
          <Row className="align-items-center g-5 px-lg-5">

            {/* IMAGE */}
            <Col md={6}>
              <div className="image-wrapper">
                <img
                  src="https://plus.unsplash.com/premium_photo-1667520477542-bf2ad7d880be?q=80&w=870&auto=format&fit=crop"
                  alt="Dry Cleaning"
                  className="img-fluid archival-img"
                />
              </div>
            </Col>


            {/* TEXT */}
            <Col md={6}>
              <div className="text-muted fs-5 text-content">
                <p>
                  Some fabrics are too refined, too delicate, too valuable for water. This is
                  precisely why dry cleaning exists — and precisely why we have mastered it
                </p>

                <p>
                  Dry cleaning is not simply a cleaning method —
                  <strong className="text-dark"> it is a preservation discipline.</strong>
                </p>


                <p>
                  Our dry cleaning service uses{" "}
                  <strong className="text-dark">
                    internationally certified solvents
                  </strong>{" "}
                  and controlled machine cycles to remove soiling, oil-based stains,
                  and environmental residue from delicate and structured garments
                  without disturbing their construction, lining, or finish.
                </p>
              </div>
            </Col>

          </Row>
        </Container>
      </section>

      <section id="services" className="py-2 bg-light">
        <Container fluid="xl" className="py-2 text-center">
          <h2 className="expertise-title">
            Key Benefits
            <div className="title-accent"></div>
          </h2>
          <p className="sub-title mb-5">Excellence in every fiber</p>
          <Row className="g-4">
            {[

              { icon: <FaWater />, title: "Solvent-based cleaning — no water", desc: "No shrinkage, no distortion, no colour bleeding" },
              { icon: <FaTshirt />, title: "Full garment structure preserved", desc: "Suits, gowns, and tailoring keep their original fit.", },
              { icon: <FaGem />, title: "Embellishment protection", desc: "Every bead, sequin, and stitch returned intact" },
              { icon: <FaWind />, title: "Deep odour elimination", desc: "Genuinely fresh — not just surface-treated" },
              { icon: <FaSearch />, title: "Expert pre-spotting per stain type", desc: "Stains treated at the source before cleaning begins." },
              { icon: <FaClock />, title: "Extended garment lifespan", desc: "Your finest pieces last years longer.", },
            ].map((benefit, idx) => (
              <Col key={idx} md={6} lg={4}>
                <Card
                  className={`benefit-card h-100 ${benefit.highlighted
                    ? "highlight-card"
                    : benefit.dark
                      ? "dark-card"
                      : ""
                    }`}
                >
                  <Card.Body>
                    <div className="icon-box">{benefit.icon}</div>

                    <h5 className="fw-bold mt-3">{benefit.title}</h5>

                    <Card.Text
                      className={benefit.dark ? "text-white-50" : "text-muted"}
                    >
                      {benefit.desc}
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>


      {/* Ideal For */}
      <section id="garments" className="py-5 bg-white">
        <Container fluid="xl" className="py-5">
          <h2 className="expertise-title">
            The garments you treasure most deserve a different kind of care. This is ours
            <div className="title-accent"></div>
          </h2>
          {/* <CleanPress/> */}

          <section className="cleanpress-main mt-5">
            <div className="cleanpress-container">
              {/* LEFT CONTENT */}
              <div className="clean-left" data-aos="zoom-in-down">
                <h2 className="expertise-title">Clean & Press</h2>

                <p className="clean-desc text-dark">
                  Designer suits and blazers, evening gowns and formal occasion wear, structured cocktail dresses, Abaya with embellishments, beaded or embroidered Jalabiya, silk garments, wool overcoats, leather-trimmed pieces, blazer-style thobes, and any garment labelled "dry clean only."
                </p>

                {/* ACTION BUTTONS */}
                <div className="btn-group">
                  <button className="order-cleanpress-news"
                    onClick={() =>
                      window.open("https://wa.me/0545718455", "_blank")
                    }>
                    Order
                  </button>
                  <button className="pricing-cleanpress-news"
                    onClick={() => navigate("/laundry-price")}>
                    Pricing
                  </button>
                </div>


              </div>

              {/* RIGHT IMAGE */}
              <div className="maxima-right" data-aos="fade-down">
                <div className="circle-ringsbxhujhsauj">
                  <img src={cleanpres} alt="Clean Press" />
                </div>
              </div>
            </div>
          </section>

          <h2 className="display-6 fw-bold mb-5">Ideal For</h2>
          <Row className="g-4">
            {[
              { name: "Designer Suits", img: "/images/OIP.jpg" },
              { name: "Evening Gowns", img: "https://images.unsplash.com/photo-1566174053879-31528523f8ae?auto=format&fit=crop&q=80&w=600" },
              { name: "Wool Overcoats", img: "https://tse1.mm.bing.net/th/id/OIP.8AYG-5eoHGan95hSYJPAiwHaHa?pid=Api&P=0&h=600" }
            ].map((item, idx) => (
              <Col key={idx} md={4}>
                <div className="category-card position-relative overflow-hidden rounded-3 shadow">
                  <img src={item.img} alt={item.name} className="img-fluid w-100 h-100 object-fit-cover transition-scale" />
                  <div className="card-overlay position-absolute bottom-0 w-100 p-4 text-white">
                    <h3 className="fw-bold h4 m-0">{item.name}</h3>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>





      {/* CTA */}


      <section id="booking" className="py-2 booking-section">
        <Container fluid="xl" className="my-2">

          <div className="cta-banner position-relative text-white text-center overflow-hidden">

            {/* CONTENT */}
            <div className="cta-content">
              <h2 className="display-4 fw-bold mb-2 fade-up text-center">
                Ready for Bespoke Care?
              </h2>

              <p className="cta-desc fade-up delay-1">
                Designer suits and blazers, evening gowns and formal occasion wear,
                structured cocktail dresses, Abaya with embellishments, beaded or
                embroidered Jalabiya, silk garments, wool overcoats, leather-trimmed
                pieces, blazer-style thobes, and any garment labelled "dry clean only."
              </p>

              <p className="fade-up delay-2">
                Protect what matters most. Book your dry cleaning through the Fresh N Clean app or WhatsApp us at
              </p>

              {/* BUTTONS */}
              <div className="cta-buttons fade-up delay-3">

                <button className="btn-main"
                  onClick={() =>
                    window.open(
                      "https://api.whatsapp.com/send?phone=971545718455&text=Hi,%20I%20would%20like%20to%20book%20a%20laundry%20pickup.",
                      "_blank"
                    )
                  }
                >BOOK VIA APP</button>
                <button className="btn-hnjjoutline-whatssp"
                  onClick={() =>
                    window.open(
                      "https://api.whatsapp.com/send?phone=971545718455&text=Hi,%20I%20would%20like%20to%20book%20a%20laundry%20pickup.",
                      "_blank"
                    )
                  }>WHATSAPP +971 54 571 8455</button>
              </div>
            </div>

            {/* BACKGROUND BLOBS */}
            <div className="blob blob-1"></div>
            <div className="blob blob-2"></div>

          </div>

        </Container>
      </section>


    </div>
  )
}
export default FreshClean;